import { checkResponse } from "./utils";
import { weatherOptions } from "./constants";

const APIkey = process.env.REACT_APP_WEATHER_API_KEY;

// Fallback location used when the browser denies/lacks geolocation.
const FALLBACK_LOCATION = { lat: 33.0198, lon: -96.6989 };

const getCurrentPosition = () => {
  return new Promise((resolve) => {
    if (!("geolocation" in navigator)) {
      resolve(FALLBACK_LOCATION);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      },
      () => resolve(FALLBACK_LOCATION),
      { timeout: 5000 }
    );
  });
};

export const getForcastWeather = () => {
  return getCurrentPosition().then(({ lat, lon }) =>
    fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${APIkey}`
    )
      .then(checkResponse)
      .catch((err) => {
        console.error(`Failed to fetch weather data: ${err}`);
        throw err;
      })
  );
};

export const parseWeatherData = (weatherData) => {
  if (!weatherData || !weatherData.main || !weatherData.weather) {
    console.error("Invalid weather data structure:", weatherData);
    return null;
  }

  const isDay = weatherData.weather[0].icon.includes("d");
  const mapWeatherType = (main) => {
    switch (main.toLowerCase()) {
      case "clear":
        return isDay ? "sunny" : "moon";
      case "clouds":
        return "cloudy";
      case "rain":
        return "rainy";
      case "thunderstorm":
        return "storm";
      case "snow":
        return "snow";
      case "fog":
      case "mist":
      case "haze":
      case "smoke":
        return "fog";
      default:
        return isDay ? "sunny" : "moon"; // Handle unexpected weather types
    }
  };
  const weatherType = mapWeatherType(weatherData.weather[0].main.toLowerCase());
  const tempKelvin = weatherData.main.temp;

  const weatherOption = weatherOptions.find((option) => {
    return option.day === isDay && option.type === weatherType;
  });

  const imageSrcUrl = weatherOption
    ? weatherOption.url
    : `http://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`;

  const weather = {
    temperature: {
      C: Math.round(tempKelvin - 273.15),
      F: Math.round(((tempKelvin - 273.15) * 9) / 5 + 32),
    },
    isDay,
    weatherType,
    imageSrcUrl,
  };
  return weather;
};
